import { createSlice } from '@reduxjs/toolkit'

const paymentFailSlice = createSlice({
    name: 'paymentFail',
    initialState: { reservation: null },
    reducers: {
        restoreBooking(state, action) {},
    },
})

const { actions, reducer } = paymentFailSlice

export const { restoreBooking } = actions

export default reducer
